/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerWindowComponent', [
    'DesignerComponent',
    function (DesignerComponent) {
      function DesignerWindowComponent() {
        DesignerComponent.apply(this);
      }

      DesignerWindowComponent.prototype = new DesignerComponent();

      DesignerWindowComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          partitioned_fields: this.partitioned_fields || this.defaults.partitioned_fields,
          ordered_fields: this.ordered_fields || this.defaults.ordered_fields,
          windowed_fields: this.windowed_fields || this.defaults.windowed_fields,
        });

        data.grouping_type = data.partitioned_fields.length ? 'group_by' : 'all';
        data.data_order = data.ordered_fields.length ? 'sort' : 'no_sort';

        return data;
      };

      DesignerWindowComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerWindowComponent.prototype.setData = function (data) {
        this.grouping_type = data.grouping_type;
        this.partitioned_fields = data.partitioned_fields;
        this.data_order = data.data_order;
        this.ordered_fields = this.data_order === 'no_sort' ? [] : data.ordered_fields;
        this.windowed_fields = data.windowed_fields;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerWindowComponent.prototype.getSchema = function () {
        const schema = DesignerComponent.prototype.getSchema.call(this);

        const windowFields = _.map(this.windowed_fields, function (field) {
          return { name: field.alias };
        });

        schema.fields = _(schema.fields).concat(windowFields).value();

        schema.id = this.id;
        schema.name = this.name;

        return schema;
      };

      return DesignerWindowComponent;
    },
  ]);
})(window.angular);
